<div class="slider-wrapper">
  <app-slider [minText]="sliderParameters.minText" [maxText]="sliderParameters.maxText" [min]='sliderParameters.min'
    [max]='sliderParameters.max' [minSelectable]='sliderParameters.minSelectable' [step]='sliderParameters.step'
    [meetId]="geefMeetid()" [value]='value' (valueChange)='sliderValueChanged($event)'>
  </app-slider>
</div>
